import {create} from "zustand";

export const informationStore = create((set) => ({
  msg : "",
  link : null,
  setInformation : (newMsg, newLink) => set({msg:newMsg, link: newLink})
}))